module.exports = __webpack_public_path__ + "static/media/item_39_3.b81499da.png";